import { render } from "./tithe-first-time.vue?vue&type=template&id=5f12130e"
import script from "./tithe-first-time.vue?vue&type=script&lang=js"
export * from "./tithe-first-time.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__